<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="epigraph"><i>And hearts that we broke long ago</i></p>
<p class="center"><i>Have long been breaking others.</i></p>
<p class="right">—W. H. Auden</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-epigraph.vue?7aa0870c